import timezones from '../../../json/timezones.json';

/** The bundled timezone lookup tables (IANA + Windows zone data). */
export const getTimezones = (): typeof timezones => timezones;

/**
 * Pluralize a noun by appending "s" (or "es" for words ending in "s") when the
 * count is not exactly one. Returns the noun unchanged when count === 1.
 */
export const pluralizeNoun = (noun: string, count = 1): string => {
    if (count === 0 || count > 1) {
        if (noun[noun.length - 1] === 's') {
            return `${noun}es`;
        }
        return `${noun}s`;
    }
    return noun;
};

/** Prefix a pluralized noun with its count, e.g. `pluralize(2, 'job')` → `2 jobs`. */
export const pluralize = (count: number, noun: string): string => {
    const pluralizedNoun = pluralizeNoun(noun, count);
    return `${count} ${pluralizedNoun}`;
};
